module.exports = __webpack_public_path__ + "img/screen_3_change.860a6d3c.png";